import {
  Box,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import React, { useEffect } from "react";

interface UserCheckboxListProps {
  users: User[];
  selectedIds:string[];
   setSelectedIds:React.Dispatch<React.SetStateAction<string[]>>,
}
interface User {
  _id: string;
  name: string;
  username:string;
}
  interface User {
  _id: string;
  name: string;
  username: string;
  teamLeaders?: string[]; // optional array of leader IDs
}


const UserCheckboxList = ({ users ,selectedIds=[] , setSelectedIds,}: UserCheckboxListProps ) => {
 

const handleChange = (id: string, teamLeaders: any[]) => {
 

  setSelectedIds((prev) => {
    const safePrev = Array.isArray(prev) ? prev : [];
    return safePrev.includes(id)
      ? safePrev.filter((item) => item !== id) // uncheck
      : [...safePrev, id]; // check
  });
};
  return (
 <Box
  sx={{
    maxHeight: 160,
    overflowY: "auto",
    border: "1px solid #E5E7EB",
    borderRadius: 1,
    px: 1,
  }}
>
  {users?.map((user) => (
    <Tooltip title={user?.username} arrow>
    <FormControlLabel
      key={user?._id}
      control={
        <Checkbox
          size="small"
          checked={selectedIds?.includes(user?._id)}
          onChange={() => handleChange(user?._id,user?.teamLeaders || [])}
        />
      }
      label={user?.name}
    />  
    </Tooltip>
  ))}
</Box>
  );
};

export default UserCheckboxList;
